import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import classnames from 'classnames';
import { NullableDropdownItem } from '@wix/da-ds/pkg/Dropdown/types';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';

import s from './ItemControlButtons.scss';

export interface Props {
  className?: string;
  moreMenuClassName?: string;
  menuItems?: NullableDropdownItem[];
  withOneClickDelete?: boolean;
  withArrowControls?: boolean;
  onDelete?: () => void;
}

export class ItemControlButtons extends React.Component<
  Props & WithTranslation
> {
  render() {
    const { t, menuItems, withOneClickDelete, moreMenuClassName, onDelete } =
      this.props;
    return (
      <div
        onClick={this.onClick}
        className={classnames(s['root'], this.props.className)}
      >
        {withOneClickDelete && (
          <IconButton
            tooltipText={t('mediapopup.delete')}
            aria-label={t('mediapopup.delete')}
            icon={TrashcanIcon}
            size="small"
            className={s['custom-icon-button-size']}
            onClick={onDelete}
          />
        )}

        {menuItems && (
          <IconButtonWithContextMenu
            standardMenuProps={{
              className: moreMenuClassName,
            }}
            items={menuItems}
            icon={EllipsisIcon}
            aria-label={t('common.more')}
            className={s['custom-icon-button-size']}
            size="small"
          />
        )}
      </div>
    );
  }
  onClick(event) {
    event.stopPropagation();
  }
}

export default withTranslation()(ItemControlButtons) as React.ComponentType<Props>;
